export const headerNamespace = 'header';
export const userSuggestNamespace = 'user-suggest';
export const navigationNamespace = 'navigation';
export const fishCardModalNamespace = 'fishCardModal';
export const digitalOfficeNamespace = 'digitalOffice';
export const loginRegistrationNamespace = 'loginRegistration';
export const applicationViewStatusNamespace = 'applicationViewStatus';
